/**
 *
 * @class OrganizationModel
 *
 * holder essential details about an organization (customer group)
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      August 2022
 *
 */
export class OrganizationModel {

  /** the database OID */
  public id: number   = 0;

  /** the unique key */
  public key: string  = '';

  /** the name */
  public name: string = '';

  /** standard constructor */
  public constructor (init?: Partial<OrganizationModel>) {

    Object.assign(this, init);
  }
}
